<main class="main-page" [class.main-page--overview]="(activeItemId() === 'dashboard' || activeItemId() === 'reports') && !activeExecutionPlanId()">
  <app-sidebar-menu
    [isOpen]="isMenuOpen()"
    [role]="currentUserRole()"
    [appName]="i18n.t('common.appName')"
    [activeItemId]="activeItemId()"
    (closeRequested)="closeMenu()"
    (itemSelected)="handleMenuItemSelection($event)"
    (actionSelected)="handleSidebarAction($event)"
  />

  <header class="main-page__topbar">
    <div class="main-page__brand">
      <button
        class="main-page__menu-button"
        type="button"
        aria-label="Open menu"
        (click)="openMenu()"
      >
        <span class="fa-solid fa-bars" aria-hidden="true"></span>
      </button>

      <img
        class="app-brand-logo main-page__brand-logo"
        src="images/juno-audit-mark.png"
        alt=""
        aria-hidden="true"
        width="64"
        height="52"
      />

      <div class="main-page__brand-copy">
        <div class="main-page__app-name">{{ i18n.t('common.appName') }}</div>
        @if (sessionStore.session()?.tenantName; as tenantName) {
          <div class="main-page__tenant-name" [title]="tenantName">{{ tenantName }}</div>
        }
        @if (userLocationNames().length) {
          <div class="main-page__user-context">
            <span class="main-page__primary-location" [title]="userLocationNames()[0]">{{ userLocationNames()[0] }}</span>
            @if (userLocationNames().length > 1) {
              <span aria-hidden="true">·</span>
              <span
                class="main-page__more-locations"
                tabindex="0"
                [title]="userLocationNames().join('\n')"
                [attr.aria-label]="userLocationNames().join(', ')"
              >+{{ userLocationNames().length - 1 }}</span>
            }
          </div>
        }
      </div>
    </div>

    <div class="main-page__account">
      <button
        class="main-page__report-incident-button"
        type="button"
        [attr.aria-label]="i18n.t('submenu.correctiveActions.reportAction')"
        (click)="openIssueReport()"
      >
        <span class="main-page__report-incident-icon" aria-hidden="true">
          <span class="fa-solid fa-triangle-exclamation"></span>
        </span>
        <span>{{ i18n.t('submenu.correctiveActions.reportAction') }}</span>
      </button>

      <!-- @if (currentUserRole() === 'AUDITOR' || currentUserRole() === 'MANAGER' || currentUserRole() === 'BUSINESS_ADMIN') 
      { -->
        <app-audit-unlock-notifications (issueRequested)="openNotificationIssue($event)" />
      <!-- } -->
      <button
        class="app-icon-button app-icon-button--inverse main-page__assistant-button"
        type="button" aria-controls="audit-assistant" aria-haspopup="dialog"
        [attr.aria-label]="i18n.t('auditAssistant.open')"
        [attr.title]="i18n.t('auditAssistant.open')"
        [attr.aria-expanded]="auditAssistant()?.isOpen() ?? false"
        (click)="auditAssistant()?.open()"
      >
        <img
          class="app-brand-logo main-page__assistant-logo"
          src="images/juno-assistant-mark.png"
          alt=""
          aria-hidden="true"
          width="44"
          height="44"
        />
      </button>

      <app-account-profile />

      <button
        class="primary-button primary-button--compact main-page__logout-button"
        type="button"
        (click)="logout()"
      >
        <span class="main-page__logout-icon" aria-hidden="true">
          <span class="fa-solid fa-right-from-bracket"></span>
        </span>
        <span>{{ i18n.t('auth.session.actions.logout') }}</span>
      </button>
    </div>
  </header>

  @if (!activeExecutionPlanId() && activeItemId() !== 'dashboard' && activeItemId() !== 'reports') {
    <app-submenu
      [activeSection]="activeItemId()"
      (createAuditRequested)="openAuditCreator()"
      (auditSearchRequested)="handleAuditSearch($event)"
      (createChecklistRequested)="openChecklistCreator()"
      (checklistSearchRequested)="handleChecklistSearch($event)"
      (createUserRequested)="openUserCreator()"
      (userSearchRequested)="handleUserSearch($event)"
      (issueSearchRequested)="handleIssueSearch($event)"
      (reportIssueRequested)="openIssueReport()"
    />
  }

  <section class="main-page__content">
    @if (activeExecutionPlanId(); as planId) {
      <app-audit-execution
        [planId]="planId"
        (closeRequested)="closeAuditExecution()"
        (completed)="closeAuditExecution()"
        (previewRequested)="openAuditExecutionPreview($event)"
      />
    } @else if (activeItemId() === 'dashboard') {
      <app-dashboard
        [reloadRequest]="issueListReloadRequest()"
        (createAudit)="createDashboardAudit()"
        (editIssue)="openDashboardIssue($event)"
      />
    } @else if (activeItemId() === 'reports') {
      <app-reports (reportIssueRequested)="openIssueReport()" />
    } @else if (activeItemId() === 'audits') {
      @if (isAuditCreatorOpen()) {
        <app-audit-creator
          [sourceAuditId]="editingAuditId()"
          (closeRequested)="closeAuditCreator()"
        />
      } @else {
        <app-audit-list
          [isActive]="true"
          [searchQuery]="auditSearchQuery()"
          (editRequested)="openAuditEditor($event)"
        />
      }
    } @else if (activeItemId() === 'checklists') {
      @if (isChecklistCreatorOpen()) {
        <app-checklist-creator
          [isOpen]="true"
          [sourceChecklistId]="editingChecklistId()"
          (closeRequested)="closeChecklistCreator()"
          (unsavedChangesChanged)="handleChecklistCreatorUnsavedChanges($event)"
        />
      } @else {
        <app-checklist-list
          [isActive]="true"
          [searchQuery]="checklistSearchQuery()"
          (editRequested)="openChecklistEditor($event)"
        />
      }
    } @else if (activeItemId() === 'users') {
      <app-user-admin
        [isActive]="true"
        [isCreating]="isUserCreatorOpen()"
        [listViewRequest]="userListViewRequest()"
        [searchQuery]="userSearchQuery()"
        mode="tenant-users"
        (creationClosed)="closeUserCreator()"
      />
    } @else if (activeItemId() === 'corrective-actions') {
      @if (editingIssue(); as issue) {
        <app-issue-editor
          [issue]="issue"
          (cancelRequested)="closeIssueEditor()"
          (saved)="handleIssueSaved()"
          (decisionUpdated)="handleIssueDecisionUpdated()"
        />
      } @else {
        <app-issue-list
          [isActive]="true"
          [searchQuery]="issueSearchQuery()"
          [reloadRequest]="issueListReloadRequest()"
          (editRequested)="openIssueEditor($event)"
        />
      }
    }
  </section>

  <app-confirmation-dialog
    [isOpen]="discardDialogOpen()"
    [title]="i18n.t('common.confirmation.title')"
    [message]="i18n.t(discardDialogMessageKey())"
    [confirmLabel]="i18n.t('common.actions.discard')"
    [cancelLabel]="i18n.t('common.actions.cancel')"
    (confirmed)="confirmChecklistCreatorDiscard()"
    (cancelled)="cancelChecklistCreatorDiscard()"
  />

  <app-audit-assistant (checklistEditRequested)="openAssistantChecklist($event)" />

  @if (isIssueReportOpen()) {
    <app-issue-report-modal (closed)="closeIssueReport()" (reported)="handleIssueReported()" />
  }

  @if (issueReportSuccessVisible()) {
    <div class="main-page__toast" role="status" aria-live="polite">
      <span class="fa-solid fa-circle-check" aria-hidden="true"></span>
      <span>{{ i18n.t('issueReport.success') }}</span>
      <button
        class="main-page__toast-close"
        type="button"
        [attr.aria-label]="i18n.t('common.actions.close')"
        (click)="dismissIssueReportSuccess()"
      >
        <span class="fa-solid fa-xmark" aria-hidden="true"></span>
      </button>
    </div>
  }
</main>
